import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ApiService } from '../../services/api/api.service';
import { AppConfigService } from '../../services/app-config/app-config.service';

@Component({
  selector: 'app-server-error',
  templateUrl: './server-error.page.html',
  styleUrls: ['./server-error.page.scss']
})
export class ServerErrorPage implements OnInit, OnDestroy {
  private static readonly RETRY_INTERVAL_MS = 10000;
  private static readonly RETURN_URL_KEY = 'serverErrorReturnUrl';

  isChecking = false;
  private retryTimer?: ReturnType<typeof setInterval>;

  constructor(
    private apiService: ApiService,
    public appConfig: AppConfigService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Sem checagem imediata: evita ping-pong se a API responde na raiz mas o endpoint da tela continua fora.
    this.retryTimer = setInterval(() => this.checkServer(), ServerErrorPage.RETRY_INTERVAL_MS);
  }

  ngOnDestroy(): void {
    clearInterval(this.retryTimer);
  }

  async checkServer(): Promise<void> {
    if (this.isChecking) {
      return;
    }

    this.isChecking = true;
    try {
      if (await this.apiService.isServerAvailable()) {
        this.returnToPreviousPage();
      }
    } finally {
      this.isChecking = false;
    }
  }

  private returnToPreviousPage(): void {
    const savedUrl = sessionStorage.getItem(ServerErrorPage.RETURN_URL_KEY);
    sessionStorage.removeItem(ServerErrorPage.RETURN_URL_KEY);
    const returnUrl = savedUrl && !savedUrl.startsWith('/server-error') ? savedUrl : '/';
    this.router.navigateByUrl(returnUrl, { replaceUrl: true });
  }
}
